import type { CSSProperties } from 'react';

/**
 * Platform design tokens.
 *
 * Use these when building modals, forms, or editor pages so the look
 * stays consistent across pgadmin. Prefer importing from
 * `components/Common/UI` rather than hard-coding values.
 *
 * Adoption rules:
 * - New components SHOULD use these tokens.
 * - Existing components are migrated opportunistically when touched.
 * - Do not introduce new spacing/colour constants outside this file
 *   without a strong reason (and document the reason here).
 */

export const space = {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
};

export const fontSize = {
    label: 11,
    caption: 12,
    body: 14,
    title: 18,
    heading: 22
};

export const fontWeight = {
    body: 400,
    medium: 500,
    bold: 600
};

export const radius = {
    sm: 4,
    md: 8,
    lg: 12,
    pill: 999
};

export const color = {
    text: {
        primary: '#1a1a1a',
        secondary: '#555',
        muted: '#888',
        danger: '#c62828',
        link: '#1976d2'
    },
    border: {
        subtle: 'rgba(0, 0, 0, 0.08)',
        default: 'rgba(0, 0, 0, 0.12)',
        focus: '#1976d2'
    },
    bg: {
        page: '#fafafa',
        card: '#ffffff',
        sectionLabel: '#f5f5f5'
    }
};

export const modalSize = {
    xs: 'xs' as const,
    sm: 'sm' as const,
    md: 'md' as const,
    lg: 'lg' as const,
    xl: 'xl' as const
};

export const sectionLabelStyle: CSSProperties = {
    fontSize: fontSize.label,
    fontWeight: fontWeight.bold,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: color.text.muted,
    lineHeight: '20px'
};

export const dangerLabelStyle: CSSProperties = {
    ...sectionLabelStyle,
    color: color.text.danger
};
